import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoRouteModule } from './video-route/video-route.module';
import { VideoLibraryService } from './service/video-library.service';

@NgModule({
  imports: [
    CommonModule,
    VideoRouteModule
  ],
  declarations: [],
  providers: [VideoLibraryService]
})
export class VideoModule { }


// WEBPACK FOOTER //
// ./src/app/section/video/video.module.ts